/**
 * Sidebar navigation tree (mirrors the prototype's js/menu-config.json) plus the
 * Material icon per top-level item. Routes are React Router paths under the
 * AdminLayout. The Settings group is collapsible.
 */
export const MENU = [
  { label: 'Dashboard', icon: 'dashboard', to: '/dashboard' },
  { label: 'Customer', icon: 'groups', to: '/customers' },
  { label: 'Sales Orders', icon: 'event_note', to: '/sales-orders' },
  { label: 'Sales Invoices', icon: 'receipt', to: '/sales-invoices' },
  { label: 'Credit Memo', icon: 'feed', to: '/credit-memos' },
  { label: 'Inventory', icon: 'inventory_2', to: '/inventory' },
  // Contractor self-service accounts waiting for a credit decision (Part 8). Badge = pending count.
  { label: 'Credit Approvals', icon: 'verified_user', to: '/credit-approvals', adminOnly: true, badge: 'creditPending' },
  { label: 'Reports', icon: 'summarize', to: '/reports' },
  {
    label: 'Settings',
    icon: 'settings',
    children: [
      { label: 'Company Profile', to: '/settings/company-profile' },
      { label: 'Integrations', to: '/settings/integrations' },
      { label: 'User Profile', to: '/settings/profile' },
      { label: 'User Management', to: '/settings/users' },
      { label: 'SKU and Discount', to: '/settings/sku-discount' },
      { label: 'Distributor', to: '/settings/distributors' },
      { label: 'Stock Locations', to: '/settings/stock-locations' },
      { label: 'Order Status', to: '/settings/order-status' },
      { label: 'Sales Representative', to: '/settings/sales-representatives' },
      { label: 'Audit Trail', to: '/settings/audit-trail' },
    ],
  },
];

export default MENU;
